export type StatusColor = 'default' | 'primary' | 'success' | 'warning' | 'error' | 'info';

export const getLoanStatusColor = (status?: string): StatusColor => {
  if (!status) return 'default';
  switch (status.toUpperCase()) {
    case 'DRAFT':
      return 'default';
    case 'SUBMITTED':
      return 'info';
    case 'UNASSIGNED':
      return 'default';
    case 'ASSIGNED':
      return 'primary';
    case 'PENDING_BA_ACCEPTANCE':
      return 'warning';
    case 'BA_REJECTED':
      return 'error';
    case 'UNDER_REVIEW':
      return 'info';
    case 'NEEDS_MORE_INFO':
    case 'MORE_INFO_REQUESTED':
    case 'REQUESTING_FOR_MORE_INFO':
    case 'ADDITIONAL_INFO_REQUIRED':
      return 'info';
    case 'INFO_PROVIDED':
      return 'success';
    case 'VALIDATION_CHECK':
    case 'ASSESSMENT_IN_PROGRESS':
      return 'info';
    case 'ASSESSMENT_COMPLETED':
      return 'success';
    case 'RISK_ASSESSMENT':
      return 'info';
    case 'RISK_APPROVED':
      return 'success';
    case 'RISK_REJECTED':
      return 'error';
    case 'PENDING_FINANCE':
      return 'warning';
    case 'FINANCE_APPROVED':
      return 'success';
    case 'FINANCE_REJECTED':
      return 'error';
    case 'PENDING_APPLICATION_FEE':
      return 'warning';
    case 'APPLICATION_FEE_PAID':
      return 'success';
    case 'PENDING_DISBURSEMENT':
      return 'warning';
    case 'DISBURSED':
      return 'success';
    case 'APPROVED':
      return 'success';
    case 'REJECTED':
      return 'error';
    case 'CANCELLED':
      return 'default';
    case 'PAYMENT_FAILED':
      return 'error';
    case 'OTHER':
      return 'default';
    default:
      return 'default';
  }
};


